import { useState } from 'react';
import { accessJsonAttr, cleanUpSpecialChars } from '../../utils/utils';
import { MgpInputFileUploadProps } from './MgpInputFileUpload.types'


export default function MgpInputFileUpload({id, required, register, errors, disabled, label, isUploadMultiple, ...props }: MgpInputFileUploadProps)  {
    const [value, setValue] = useState(props.value);

    let divClassName = "file-upload-mobile p-x-md" ;
    
    let fieldError;

    if(errors) {
        fieldError = accessJsonAttr(errors, id);
        if(fieldError) {
            divClassName += " error";
        }
    }

    const onChangeEvent = (e: any) => {
        if(props.autoCapitalize ==='characters') {
            setValue(cleanUpSpecialChars(e.currentTarget.value).toUpperCase());
        } else if(props.autospace) {
            const regexSpace = new RegExp("(.{"+ props.autospace + "})", "g");
            setValue(e.currentTarget.value.replace(/[^A-Z0-9]/g, '').replace(regexSpace, '$1 ').trim());
        }
        else {
            setValue(e.currentTarget.value);
        }
        
        if(props.onChange) {
            props.onChange(e);
        }    
    }
  
       
    
        return (
            <div className={divClassName} >
                {register&&<input  {...props} type="file" id={id} {...register(id, {onChange:(e) => {onChangeEvent(e)}})}  value={props.unsetValue ? '' : value} />}
                {!register&&<input  {...props} type="file" id={id} value={props.unsetValue ? '' : value} onChange={onChangeEvent} />}
                
                <label className='form-label' htmlFor={id}>
                    <i className='icon-telechargement-2 fz-xl' />
                    <p className='text fw-medium'>
                        {label ?? "Vos documents sont sur votre appareil"} {required ? <span className='fushia'> (*)</span>: ''}
                    </p>
                    <div>
                        <p className='bleu fz-xs'>Taille maximum {isUploadMultiple ? '4 MB' : '8 MB'}</p>
                        <p className='bleu fz-xs'>Formats .pdf, .jpg, .jpeg ou .png</p>
                    </div>
                </label>
            </div> 
        );
    
}

    